import { Controller } from 'stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = [ 'list' ]

  connect() {
    this.sortables = this.listTargets.map(list => Sortable.create(list, {
      handle:     '.ui-modal__row__handle',
      animation:  150,
      ghostClass: 'ui-modal__row--ghost'
    }))
  }

  disconnect() {
    this.sortables.forEach(sortable => sortable.destroy())
  }

  up(event) {
    const row      = event.currentTarget.closest('.ui-modal__row')
    const previous = row.previousElementSibling
    if (previous) row.parentNode.insertBefore(row, previous)
    event.currentTarget.focus()
  }

  down(event) {
    const row  = event.currentTarget.closest('.ui-modal__row')
    const next = row.nextElementSibling
    if (next) row.parentNode.insertBefore(next, row)
    event.currentTarget.focus()
  }
}
